module.exports = __webpack_public_path__ + "static/media/hlb.6eca1337.jpg";